"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ViewsController", {
    enumerable: true,
    get: function() {
        return ViewsController;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewrowcolorservice = require("~/services/view-row-color.service");
const _PagedResponse = require("~/helpers/PagedResponse");
const _globalguard = require("~/guards/global/global.guard");
const _viewsservice = require("~/services/views.service");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let ViewsController = class ViewsController {
    async viewList(context, tableId, req) {
        return new _PagedResponse.PagedResponseImpl(await this.viewsService.viewList(context, {
            tableId,
            user: req.user
        }));
    }
    async viewRowColorInfo(context, viewId) {
        return await this.viewRowColorService.getByViewId({
            context,
            fk_view_id: viewId
        });
    }
    async viewRowColorInfoDelete(context, viewId) {
        return await this.viewRowColorService.removeRowColorInfo({
            context,
            fk_view_id: viewId
        });
    }
    async viewUpdate(context, viewId, body, req) {
        const result = await this.viewsService.viewUpdate(context, {
            viewId,
            view: body,
            user: req.user,
            req
        });
        return result;
    }
    async viewDelete(context, viewId, req) {
        const result = await this.viewsService.viewDelete(context, {
            viewId,
            user: req.user,
            req
        });
        return result;
    }
    async showAllColumns(context, viewId, ignoreIds) {
        return await this.viewsService.showAllColumns(context, {
            viewId,
            ignoreIds
        });
    }
    async hideAllColumns(context, viewId, ignoreIds) {
        return await this.viewsService.hideAllColumns(context, {
            viewId,
            ignoreIds
        });
    }
    async shareView(context, viewId, req) {
        return await this.viewsService.shareView(context, {
            viewId,
            user: req.user,
            req
        });
    }
    async shareViewList(context, tableId) {
        return new _PagedResponse.PagedResponseImpl(await this.viewsService.shareViewList(context, {
            tableId
        }));
    }
    async shareViewUpdate(context, viewId, body, req) {
        return await this.viewsService.shareViewUpdate(context, {
            viewId,
            sharedView: body,
            user: req.user,
            req
        });
    }
    async shareViewDelete(context, viewId, req) {
        return await this.viewsService.shareViewDelete(context, {
            viewId,
            user: req.user,
            req
        });
    }
    constructor(viewsService, viewRowColorService){
        this.viewsService = viewsService;
        this.viewRowColorService = viewRowColorService;
    }
};
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId/views',
        '/api/v2/meta/tables/:tableId/views'
    ]),
    (0, _extractidsmiddleware.Acl)('viewList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "viewList", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/views/:viewId/row-color'
    ]),
    (0, _extractidsmiddleware.Acl)('viewRowColorInfo'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "viewRowColorInfo", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/views/:viewId/row-color'
    ]),
    (0, _extractidsmiddleware.Acl)('viewRowColorInfoDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "viewRowColorInfoDelete", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/views/:viewId',
        '/api/v2/meta/views/:viewId'
    ]),
    (0, _extractidsmiddleware.Acl)('viewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _nocodbsdk.ViewUpdateReqType === "undefined" ? Object : _nocodbsdk.ViewUpdateReqType,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "viewUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/views/:viewId',
        '/api/v2/meta/views/:viewId'
    ]),
    (0, _extractidsmiddleware.Acl)('viewDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "viewDelete", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/show-all',
        '/api/v2/meta/views/:viewId/show-all'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('showAllColumns'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Query)('ignoreIds')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Array
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "showAllColumns", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/hide-all',
        '/api/v2/meta/views/:viewId/hide-all'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('hideAllColumns'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Query)('ignoreIds')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Array
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "hideAllColumns", null);
_ts_decorate([
    (0, _common.Post)([
        '/api/v1/db/meta/views/:viewId/share',
        '/api/v2/meta/views/:viewId/share'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('shareView'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "shareView", null);
_ts_decorate([
    (0, _common.Get)([
        '/api/v1/db/meta/tables/:tableId/share',
        '/api/v2/meta/tables/:tableId/share'
    ]),
    (0, _extractidsmiddleware.Acl)('shareViewList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('tableId')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "shareViewList", null);
_ts_decorate([
    (0, _common.Patch)([
        '/api/v1/db/meta/views/:viewId/share',
        '/api/v2/meta/views/:viewId/share'
    ]),
    (0, _extractidsmiddleware.Acl)('shareViewUpdate'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Body)()),
    _ts_param(3, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        Object,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "shareViewUpdate", null);
_ts_decorate([
    (0, _common.Delete)([
        '/api/v1/db/meta/views/:viewId/share',
        '/api/v2/meta/views/:viewId/share'
    ]),
    (0, _extractidsmiddleware.Acl)('shareViewDelete'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Param)('viewId')),
    _ts_param(2, (0, _common.Req)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        String,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest
    ]),
    _ts_metadata("design:returntype", Promise)
], ViewsController.prototype, "shareViewDelete", null);
ViewsController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _viewsservice.ViewsService === "undefined" ? Object : _viewsservice.ViewsService,
        typeof _viewrowcolorservice.ViewRowColorService === "undefined" ? Object : _viewrowcolorservice.ViewRowColorService
    ])
], ViewsController);
